const DEFAULT_WEB_ORIGIN = 'https://club-roots.co.uk';

/**
 * Shared links must never derive from location.origin: the native webview serves the
 * app from a private scheme (capacitor://localhost / https://localhost) that nobody
 * outside the device can open.
 */
export const getShareOrigin = (): string =>
  String(import.meta.env.VITE_PUBLIC_WEB_ORIGIN || DEFAULT_WEB_ORIGIN).replace(/\/+$/, '');

/**
 * Builds a public link in path form (`/team/x`), never hash form (`/#/team/x`).
 * iOS universal links only match the path before `#`, so hash links would all look
 * like `/` and could never open the app. Hosting redirects convert these back to
 * hash routes for browsers, except shared results which initialise the hash in
 * place so Safari retains the path-form App Clip invocation URL.
 */
export const buildShareUrl = (route: string): string => {
  const origin = getShareOrigin();
  const path = (route || '').replace(/^#/, '');
  if (!path || path === '/') return `${origin}/`;
  return `${origin}${path.startsWith('/') ? path : `/${path}`}`;
};
